import {EditField, InputFieldsReturn} from 'priority-web-sdk';
import {addNewStandAloneForm} from '../../Form/actions/standAloneForm';
import {Form} from '../../../stores/Form';
import {runProcedure} from '../../../services/webSdk/proc';
import {startAndFetchSubform} from '../../Form/actions/batchedActions/standAloneFormBatch';

export const getFiscalYearForm = (year: string): Promise<Form> => {
    return addNewStandAloneForm('GENLEDGERS', {GLNAME: year});
};

export const getFiscalPeriodsForm = async (form: Form): Promise<Form> => {
    await startAndFetchSubform(form, 'GLPERIODS');
    return form.activeSubForm;
};

export const runOpenFiscalPeriodProc = async (year: string, toPeriod: number) => {
    await runProcedure('OPENGL', updateInputFields(year, toPeriod), undefined);
};

const updateInputFields =
    (year: string, toPeriod: number) =>
    (inputFields: EditField[]): InputFieldsReturn => {
        const inputFieldsReturn = inputFields.map(field => {
            let value = field.value;

            switch (field.field) {
                case 1:
                    value = toPeriod.toString();
                    break;
                case 2:
                    value = year;
                    break;
                case 3:
                    value = 'N';
            }
            return {
                field: field.field,
                op: 0,
                value: value,
                op2: 0,
                value2: value
            };
        });
        return {EditFields: inputFieldsReturn};
    };
